import { castResponse } from "@utils/hooks/useTypedRequest";
import { IMiningPlanOptions } from "./getMinerList";
import { PostRequest } from "./http/BaseRequest";
import { RecordResponse, RecordsResponse } from "./http/responses/BaseResponse";
import W2UiFilterBuilder from "./w2ui";

export interface MiningPlanParamsI extends Omit<IMiningPlanOptions, "id"> {
  readonly id?: number;
  readonly edit?: boolean;
}
/*
export const createMiningPlan = (
  params: MiningPlanParamsI
): Promise<AxiosResponse<ServerResponse> | Error> => {
  return service.api.post("/admin/plan/add", {
    ...params,
    days: JSON.stringify(params.days),
    time_picker: JSON.stringify(params.time_picker),
  });
};
export const deleteMiningPlan = (
  id: string
): Promise<AxiosResponse<ServerResponse> | Error> => {
  return service.api.post("/admin/plan/delete", {
    id,
  });
};
*/
export class CreateMiningPlanRequest extends PostRequest {
  constructor(params: MiningPlanParamsI) {
    super("/admin/plan/add", {
      ...params,
      schedule: JSON.stringify(params.schedule),
      // days: JSON.stringify(params.days),
      // time_picker: JSON.stringify(params.time_picker),
    });
  }
}

export class DeleteMiningPlanRequest extends PostRequest {
  constructor(id: number) {
    super("/admin/plan/delete", {
      id,
    });
  }
}

export const getPlanTemplates = {
  makeRequest() {
    const builder = new W2UiFilterBuilder();
    builder.setLimit(2000);
    return new PostRequest(
      "/admin/plan_schedule_template/w2ui",
      builder.build().stringParams
    );
  },
  makeResponse: castResponse<RecordsResponse<{ Id: number, PlanId: number, Meta: string }>>,
};

export const createPlanTemplates = {
  makeRequest(planid: number, meta: string) {
    const builder = new W2UiFilterBuilder();
    builder.setEdit({ recid: "new", planid, meta });
    return new PostRequest(
      "/admin/plan_schedule_template/w2ui",
      builder.build().stringParams
    );
  },
  makeResponse: castResponse<RecordsResponse<{ Id: number, PlanId: number, Meta: string }>>,
};

export const deletePlanTemplates = {
  makeRequest(ids: number[]) {
    const builder = new W2UiFilterBuilder();
    builder.setDelete(...ids);
    return new PostRequest(
      "/admin/plan_schedule_template/w2ui",
      builder.build().stringParams
    );
  }
}

export const savePlanToMiner = {
  makeRequest(miner: number, miner_plan: number) {
    return new PostRequest("/admin/miner/settings/change", {
      miner,
      miner_plan,
    });
  },
  makeResponse: castResponse<RecordResponse<{}>>,
};
